// extracted by mini-css-extract-plugin
export var bodySections = "_bg-8";
export var gray = "_bg-7";
export var green = "_bg-4";
export var iconContainer = "_bg-9";
export var iconWidgetContainer = "_bg-1";
export var phoneIcon = "_bg-2";
export var red = "_bg-5";
export var statusDot = "_bg-3";
export var widgetContainer = "_bg-0";
export var yellow = "_bg-6";